import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/about/bubble-gum-yellow-star-1 1.png")